export default __webpack_public_path__ + "static/media/individual.d327ddde.png";